export {default as FundsContentBlocks, getFundsContentBlock} from './FundsContentBlocks'